import {v4 as uuidv4} from "uuid";

export function generateGUID() {
  let userGUID = localStorage.getItem("splitUserID")
  if (!userGUID) {
    userGUID = uuidv4()

    localStorage.setItem("splitUserID", userGUID)
  }
  return userGUID
}
